module.exports = __webpack_public_path__ + "img/unitReadyCompressed.65ab7636.gif";